export interface SpreadsheetData {
  table: {
    cols: Array<{ label: string; type: string }>;
    rows: Array<{
      c: Array<{ v: string | number | null; f?: string }>;
    }>;
  };
}

export class GoogleSheetsService {
  private baseUrl: string;

  constructor(spreadsheetId: string, gid: string = '0') {
    // URL para obter os dados da planilha via endpoint gviz/tq em formato JSON
    // gid: 0=primeira aba, 1=segunda aba, etc.
    this.baseUrl = `https://docs.google.com/spreadsheets/d/${spreadsheetId}/gviz/tq?tqx=out:json&gid=${gid}`;
  }

  // Carrega o JSON "cru" dos dados da planilha
  async loadSpreadsheet(): Promise<SpreadsheetData | null> {
    try {
      console.log('Carregando dados da planilha:', this.baseUrl);
      const response = await fetch(this.baseUrl);
      const text = await response.text();
      
      // O retorno da planilha possui um wrapper; extraímos somente o JSON
      const jsonData = JSON.parse(text.substring(text.indexOf('{'), text.lastIndexOf('}') + 1));
      console.log('Dados da planilha carregados:', jsonData);
      return jsonData;
    } catch (error) {
      console.error('Erro ao carregar as configurações da planilha:', error);
      return null;
    }
  }
} 